<template>
    <svg fill="none" height="17" viewBox="0 0 16 17" width="16" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.4998 5.25H3.49976V6.25H12.4998V5.25Z" fill="currentColor" />
        <path d="M12.4998 7.99988H3.49976V8.99988H12.4998V7.99988Z" fill="currentColor" />
        <path d="M8.24975 10.7499H3.49976V11.7499H8.24975V10.7499Z" fill="currentColor" />
        <path d="M14.9998 2H0.999756V15H14.9998V2ZM13.9998 14H1.99976V3H13.9998V14Z" fill="currentColor" />
    </svg>
</template>
